var $710820ae83154a30$exports = {};
$710820ae83154a30$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Odabrani datum nije dostupan`,
            other: `Odabrani datumi nisu dostupni`
        })}.`
};


export {$710820ae83154a30$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
